import { createContext } from 'react';

const HandwritingConfigContext = createContext(null);

export default HandwritingConfigContext;